<button class="save-btn" color="primary" mat-flat-button [disabled]="!hasChanges || isLoading" (click)="onSave()">
    <mat-icon [class.loading]="isLoading">{{ icon }}</mat-icon> {{ btnText }}
</button>
